import {
	CLEAR_INVESTOR_MANAGEMENT_STATE,
	GET_ALL_INVESTORS,
	GET_ALL_INVESTORS_SUCCESS,
	GET_ALL_INVESTORS_ERROR,
	GET_INVESTOR_BY_ID,
	GET_INVESTOR_BY_ID_SUCCESS,
	GET_INVESTOR_BY_ID_ERROR,
	CREATE_INVESTOR,
	CREATE_INVESTOR_SUCCESS,
	CREATE_INVESTOR_ERROR,
	UPDATE_INVESTOR,
	UPDATE_INVESTOR_SUCCESS,
	UPDATE_INVESTOR_ERROR,
	DELETE_INVESTOR,
	DELETE_INVESTOR_SUCCESS,
	DELETE_INVESTOR_ERROR,
	GET_USERS_BY_INVESTOR,
	GET_USERS_BY_INVESTOR_SUCCESS,
	GET_USERS_BY_INVESTOR_ERROR,
} from './actions';
import api from '@/utils/api';

const { http } = api.getInstance();
const USER_URL = '/users';
const INVESTOR_URL = '/investor';

const defaultState = () => ({
	investorList: [],
	investorUserList: [],
	isLoadingInvestors: '',
	isLoadingInvestorsUsers: '',
});

const state = defaultState();

const getters = {
	investorList: (state) => state.investorList,
	investorUserList: (state) => state.investorUserList,
	isLoadingInvestors: (state) => state.isLoadingInvestors === 'loading',
	isLoadingInvestorsUsers: (state) => state.isLoadingInvestorsUsers === 'loading',
};

const mutations = {
	[CLEAR_INVESTOR_MANAGEMENT_STATE]: (state) => {
		Object.assign(state, defaultState());
	},
	[GET_ALL_INVESTORS]: (state) => {
		state.isLoadingInvestors = 'loading';
	},
	[GET_ALL_INVESTORS_SUCCESS]: (state, data) => {
		state.investorList = data;
		state.isLoadingInvestors = 'success';
	},
	[GET_ALL_INVESTORS_ERROR]: (state) => {
		state.isLoadingInvestors = 'error';
	},
	[GET_INVESTOR_BY_ID]: (state) => {
		state.isLoadingInvestors = 'loading';
	},
	[GET_INVESTOR_BY_ID_SUCCESS]: (state, data) => {
		state.isLoadingInvestors = 'success';
	},
	[GET_INVESTOR_BY_ID_ERROR]: (state) => {
		state.isLoadingInvestors = 'error';
	},
	[CREATE_INVESTOR]: (state) => {
		state.isLoadingInvestors = 'loading';
	},
	[CREATE_INVESTOR_SUCCESS]: (state) => {
		state.isLoadingInvestors = 'success';
	},
	[CREATE_INVESTOR_ERROR]: (state) => {
		state.isLoadingInvestors = 'error';
	},
	[UPDATE_INVESTOR]: (state) => {
		state.isLoadingInvestors = 'loading';
	},
	[UPDATE_INVESTOR_SUCCESS]: (state, data) => {
		state.isLoadingInvestors = 'success';
	},
	[UPDATE_INVESTOR_ERROR]: (state) => {
		state.isLoadingInvestors = 'error';
	},
	[DELETE_INVESTOR]: (state) => {
		state.isLoadingInvestors = 'loading';
	},
	[DELETE_INVESTOR_SUCCESS]: (state, data) => {
		state.isLoadingInvestors = 'success';
	},
	[DELETE_INVESTOR_ERROR]: (state) => {
		state.isLoadingInvestors = 'error';
	},
	[GET_USERS_BY_INVESTOR]: (state) => {
		state.isLoadingInvestorsUsers = 'loading';
	},
	[GET_USERS_BY_INVESTOR_SUCCESS]: (state, data) => {
		state.investorUserList = data;
		state.isLoadingInvestorsUsers = 'success';
	},
	[GET_USERS_BY_INVESTOR_ERROR]: (state) => {
		state.isLoadingInvestorsUsers = 'error';
	},
};

const actions = {
	[GET_ALL_INVESTORS]: async ({ commit }, { vm, params }) => {
		return new Promise((resolve, reject) => {
			commit(GET_ALL_INVESTORS);
			localStorage.setItem(`lastReqAdm`, 'investorManagement/GET_ALL_INVESTORS');

			http({
				method: 'GET',
				url: `${INVESTOR_URL}/list${params}`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_ALL_INVESTORS_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_ALL_INVESTORS_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[GET_INVESTOR_BY_ID]: async ({ commit }, { vm, id }) => {
		return new Promise((resolve, reject) => {
			commit(GET_INVESTOR_BY_ID);

			http({
				method: 'GET',
				url: `${INVESTOR_URL}/${id}`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_INVESTOR_BY_ID_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_INVESTOR_BY_ID_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[CREATE_INVESTOR]: async ({ commit }, { vm, body }) => {
		return new Promise((resolve, reject) => {
			commit(CREATE_INVESTOR);

			http({
				method: 'POST',
				url: `${INVESTOR_URL}`,
				data: body,
			})
				.then((response) => {
					resolve(response);
					vm.$toastr.s('Investidor criado com sucesso.');
					commit(CREATE_INVESTOR_SUCCESS);
				})
				.catch((error) => {
					reject(error);
					commit(CREATE_INVESTOR_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[UPDATE_INVESTOR]: async ({ commit }, { vm, id, body }) => {
		return new Promise((resolve, reject) => {
			commit(UPDATE_INVESTOR);

			http({
				method: 'PATCH',
				url: `${INVESTOR_URL}/${id}`,
				data: body,
			})
				.then((response) => {
					resolve(response);
					vm.$toastr.s('Investidor editado com sucesso.');
					commit(UPDATE_INVESTOR_SUCCESS);
				})
				.catch((error) => {
					reject(error);
					commit(UPDATE_INVESTOR_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[DELETE_INVESTOR]: async ({ commit }, { vm, id }) => {
		return new Promise((resolve, reject) => {
			commit(DELETE_INVESTOR);

			http({
				method: 'DELETE',
				url: `${INVESTOR_URL}/${id}`,
			})
				.then((response) => {
					resolve(response);
					vm.$toastr.s('Investidor excluído com sucesso.');
					commit(DELETE_INVESTOR_SUCCESS);
				})
				.catch((error) => {
					reject(error);
					commit(DELETE_INVESTOR_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[GET_USERS_BY_INVESTOR]: async ({ commit }, { vm, id, params }) => {
		return new Promise((resolve, reject) => {
			commit(GET_USERS_BY_INVESTOR);

			http({
				method: 'GET',
				url: `${USER_URL}${INVESTOR_URL}/${id}${params}`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_USERS_BY_INVESTOR_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_USERS_BY_INVESTOR_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	}
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
